<template>
    <CodiceFeanorView tool-module="caesar" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
